import axios from "axios";

export const API = {
  baseURL:"https://api.qhealthclinics.com/",
  // baseURL: "https://api-qhealth.equitysofttechnologies.com/",
  // baseURL: "https://api.qhealth.com.au/",

  // Auth
  login: "api/auth/admin_login",

  // USER
  GetAllUsers: "/api/user/get_all",
  user: "/api/user/get",
  RecentUser: "/api/admin/recent_user_get",
  PremiumUser: "/api/admin/Premium_get_all",
  GetAnalytics: "/api/admin/analytics",
  editUser: "/api/user/edit",
  GetUserbyID: "/api/user/get_users",

  // Product
  getProductUrl: "api/admin/product_get",
  AddProductUrl: "/api/admin/product_add",
  singleproduct: "/api/admin/product_get_id",
  editProduct: "/api/admin/product_edit",

  // Product Category
  getproductcategory: "/api/admin/product/cat-list",
  addproductcategory: "/api/admin/product/cat-add",
  updateproductcategory: "/api/admin/product/cat-edit",

  // Diet Category
  getdietcategory: "/api/admin/diet-plan/cat-list",
  adddietcategory: "/api/admin/diet-plan/cat-add",
  updatedietcategory: "/api/admin/diet-plan/cat-edit",

  //PageLinks
  HomepageLinks: "/api/admin/get_links",
  HomepageLinksid: "/api/admin/get_id_links",
  AddHomepageLinks: "api/admin/add_links",
  UpdateHomepageLink: "/api/admin/edit_links",

  // Services
  GetService: "/api/admin/get_service",
  AddService: "/api/admin/add_service",
  EditService: "/api/admin/edit_service",
  SingleService: "/api/admin/get_id_service",

  // Coupon
  GetCoupon: "/api/admin/get_coupon",
  AddCoupon: "/api/admin/add_coupon",
  EditCoupon: "/api/admin/edit_coupon",
  singlecoupon: "/api/admin/coupon_get_id",

  //  Voucher
  GetVoucher: "/api/admin/get_voucher",
  AddVoucher: "/api/admin/add_voucher",
  editvoucher: "/api/admin/edit_voucher",
  singlevoucher: "/api/admin/get_id_voucher",

  // Workout-plans
  GetWorkout: "/api/admin/get_workout",
  SingleWorkout: "/api/admin/get_id_workout",
  EditWorkout: "/api/admin/edit_workout",
  AddWorkout: "/api/admin/add_workout",

  // Recipe
  GetRecipe: "/api/admin/recipe_get",
  SingleRecipe: "/api/admin/recipe_get_id",
  EditRecipe: "/api/admin/recipe_edit",
  AddRecipe: "/api/admin/recipe_add",

  // Challenges
  GetChallenges: "/api/admin/get_challenges",
  AddChallenges: "/api/admin/add_challenges",
  SingleChallenge: "/api/admin/challenges_get_id",
  EditChallenges: "/api/admin/edit_challenges",

  //DietPlans
  GetDiet: "/api/admin/get_plan",
  AddDiet: "/api/admin/add_plan",
  SingleDiet: "/api/admin/get_id_diet_recipe",
  EditDiet: "/api/admin/edit_plan",

  // Q & A
  GetQuestions: "/api/admin/get_que",
  AddQuestions: "/api/admin/add_que",
  DeleteQuestion: "/api/admin/delete_que",
  SingleQuestion: "/api/admin/get_que_id",

  //Order
  GetOrder: "/api/user/orders_get",
  GetOrderById: "/api/user/orders_get_id",
  EditOrderStatus: "/api/user/order_update",

  // Notification
  SendNotification: "/api/notification/send",

  // Controller
  AddController: "/api/admin/controller-add",
  GetSubadmin: "/api/admin/controller-list",
  SingleSubAdmin: "/api/admin/controller-get-id",
  EditSubAdmin: "/api/admin/controller-edit",

  addpolicy: "/api/admin/general-docs-edit",
  getpolicy: "/api/admin/general-docs-get",
};

const Axios = axios.create({
  baseURL: API.baseURL,
});

export const API_GET_ID = async (url, id) => {
  try {
    const token = localStorage.getItem("token");
    const apikey = localStorage.getItem("apikey");

    // const uri = `${url}/${id}`;

    const { data } = await Axios.get(url, {
      params: {
        id: id,
        token: token,
        apikey: apikey,
      },
      headers: {
        // Add any headers you need here
      },
    });

    return data;
  } catch (error) {
    return error;
  }
};
export const API_GET_TYPE = async (url, type) => {
  try {
    const token = localStorage.getItem("token");
    const apikey = localStorage.getItem("apikey");

    let uri = `${url}?type=${type}&token=${token}&apikey=${apikey}`;

    const { data } = await Axios.get(uri, {
      headers: null,
    });

    // const { data } = await Axios.get(url, {
    //   params: {
    //     id: id,
    //     token: token,
    //     apikey: apikey,
    //   },
    //   headers: {
    //     // Add any headers you need here
    //   },
    // });

    return data;
  } catch (error) {
    return error;
  }
};
export const API_GET = async (url) => {
  try {
    const token = localStorage.getItem("token");
    const apikey = localStorage.getItem("apikey");

    const uri = url + "?token=" + token + "&apikey=" + apikey;

    const { data } = await Axios.get(uri, {
      headers: null,
    });

    return data;
  } catch (error) {
    return error;
  }
};
export const API_GET_P = async (url, count, usertype) => {
  console.log("u", usertype);
  try {
    const token = localStorage.getItem("token");
    const apikey = localStorage.getItem("apikey");

    // Initialize the URI with the base URL and common parameters
    let uri = `${url}?count=${count}&token=${token}&apikey=${apikey}`;
    if (usertype) {
      uri = `${url}?type=${usertype}&token=${token}&apikey=${apikey}`;
    }

    const { data } = await Axios.get(uri, {
      headers: null,
    });

    return data;
  } catch (error) {
    return error;
  }
};
export const API_GET_ORDER = async (url, usertype) => {
  console.log("u", usertype);
  try {
    const token = localStorage.getItem("token");
    const apikey = localStorage.getItem("apikey");

    // Initialize the URI with the base URL and common parameters
    let uri = `${url}&token=${token}&apikey=${apikey}`;
    if (usertype) {
      uri = `${url}?type=${usertype}&token=${token}&apikey=${apikey}`;
    }
    const { data } = await Axios.get(uri, {
      headers: null,
    });

    return data;
  } catch (error) {
    return error;
  }
};

export const API_POST = async (url, data) => {
  const token = localStorage.getItem("token");
  const apikey = localStorage.getItem("apikey");

  const uri = url + "?token=" + token + "&apikey=" + apikey;

  try {
    const res = await Axios.post(uri, data, {
      headers: null,
    });

    return res.data;
  } catch (error) {
    return error;
  }
};

export const API_GET_SEARCH = async (type, searchterm, recipetype) => {
  try {
    const token = localStorage.getItem("token");
    const apikey = localStorage.getItem("apikey");
    if (recipetype) {
      const url = `/api/admin/search?type=${type}&search=${searchterm}&token=${token}&apikey=${apikey}&recipe_type=${recipetype}`;
      const { data } = await Axios.get(url, {});
      return data;
    } else {
      const url = `/api/admin/search?type=${type}&search=${searchterm}&token=${token}&apikey=${apikey}`;
      const { data } = await Axios.get(url, {});
      return data;
    }
  } catch (error) {
    return error;
  }
};
